import React from "react";
import {Collapse} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {BulletText} from "./markerStyles";
import {courierTypes, deliveryStatuses, mapCourierStatuses} from "../../../constants/constants";
import {formatPhoneNumber, isConstantExist, getConstant} from "../../../utils/helpers";
import {useStore} from "../../../hooks/useStore";

export const ReceiverPopupContent = ({delivery, allOrdersOfDelivery, order, courierStatus}) => {
    const stores = useStore();
    const history = useHistory();
    const {t} = useTranslation([
        "courierTypes",
        "courierStatuses",
        "mapCourierStatuses",
        "deliveryStatuses",
        "common"
    ]);

    return (
        <Collapse defaultActiveKey={[1]} bordered={false}>
            <Collapse.Panel
                header={t("fields.order", {ns: "common"})}
                key="1"
                extra={
                    stores.meStore.checkRole("orderDetail") && (
                        <InfoCircleOutlined
                            onClick={() => history.push("/orders/" + delivery._id)}
                        />
                    )
                }
            >
                <div style={{marginBottom: "8px"}}>
                    {isConstantExist(deliveryStatuses, delivery?.deliveryState)
                        ? t(
                              `${
                                  getConstant(deliveryStatuses, delivery?.deliveryState)
                                      .translation_key
                              }.name`,
                              {
                                  ns: "deliveryStatuses"
                              }
                          )
                        : "-"}
                </div>
                {allOrdersOfDelivery?.map((orderItem, i) => (
                    <BulletText
                        key={i}
                        color={
                            !orderItem.stepInfo.canceled
                                ? orderItem.stepIndex < delivery?.currentStepIndex && "green"
                                : orderItem.stepIndex < delivery?.currentStepIndex && "red"
                        }
                        thick={orderItem._id === order._id}
                    >
                        {`${orderItem.stepInfo.receiverName}, ${formatPhoneNumber(
                            orderItem.stepInfo.receiverPhone
                        )}`}
                    </BulletText>
                ))}
            </Collapse.Panel>
            {delivery?.assignedCourier && (
                <Collapse.Panel
                    header={delivery?.assignedCourier?.fullname}
                    key="2"
                    extra={
                        stores.meStore.checkRole("courierDetail") && (
                            <InfoCircleOutlined
                                onClick={() =>
                                    history.push("/couriers/" + delivery.assignedCourier._id)
                                }
                            />
                        )
                    }
                >
                    <BulletText>
                        {formatPhoneNumber(delivery?.assignedCourier?.cellPhone)}
                    </BulletText>
                    <BulletText>
                        {isConstantExist(courierTypes, delivery?.assignedCourier?.type)
                            ? t(
                                  getConstant(courierTypes, delivery?.assignedCourier.type)
                                      .translation_key,
                                  {
                                      ns: "courierTypes"
                                  }
                              )
                            : "-"}
                    </BulletText>
                </Collapse.Panel>
            )}

            <Collapse.Panel header={t("fields.pickupLocations", {ns: "common"})} key="3">
                {delivery?.pickupInfos
                    ?.sort((prev, curr) => prev.index - curr.index)
                    ?.map((pickup, i) => (
                        <React.Fragment key={i}>
                            <BulletText>
                                {pickup.name}, {formatPhoneNumber(pickup.phone)}
                            </BulletText>
                        </React.Fragment>
                    ))}
            </Collapse.Panel>
        </Collapse>
    );
};
